<template lang="pug">
  .support-box.no-print
    .fixed-support.mr-3(ref='supportBox')
      .card.shadow.support#support-box
        .card-header.text-white.bg-info
          | Support
          button.close.text-white(type='button', data-dismiss='modal', aria-label='Close', @click='closeSupport')
            span(aria-hidden='true') &times;
        .card-body
          p.card-text {{ message }}
          a.btn.btn-info.text-white(@click='handleHelpButtonClick') Start Tour
    .fixed-help(ref='helpButton', :class='helpButtonClass')
      CoachmarkTip(:options='supportCoachmark')
        a.btn.btn-info.help-button#help-button(@click='openSupport')
          font-awesome-icon.text-white(:icon='["fas", "question"]')
</template>

<script>
import { includes } from 'lodash';
import eventBus from '@api/eventBus';
import CoachmarkTip from '@components/CoachmarkTip';

const _ = { includes };

const SHOW_SUPPORT_CLASS = 'show-support';
const SHOW_HELP_BUTTON_CLASS = 'show-help-button';

export default {
  name: 'SupportBox',
  components: {
    CoachmarkTip
  },
  props: {
    message: String,
    visible: Boolean,
    type: String
  },
  data: () => ({
  }),
  computed: {
    helpButtonClass: function () {
      return this.visible ? SHOW_HELP_BUTTON_CLASS : '';
    },
    supportCoachmark: function () {
      return {
        order: '0',
        text: 'Click or tap this box to show a helpful walkthrough anywhere you need it.',
        type: 'watSupport'
      };
    }
  },
  methods: {
    handleHelpButtonClick: function () {
      eventBus.bus.$emit(eventBus.CHANNEL_CLICKED_HELP, {
        startNew: true,
        type: this.type
      });
      this.closeSupport();
    },
    openSupport: function () {
      if (!_.includes(this.$refs.supportBox.classList, SHOW_SUPPORT_CLASS)) {
        this.$refs.supportBox.classList.add(SHOW_SUPPORT_CLASS);
        this.toggleHelpButton();
      }
    },
    closeSupport: function (event) {
      if (event) {
        event.stopPropagation();
      }

      if (_.includes(this.$refs.supportBox.classList, SHOW_SUPPORT_CLASS)) {
        this.$refs.supportBox.classList.remove(SHOW_SUPPORT_CLASS);
        this.toggleHelpButton();
      }
    },
    toggleHelpButton: function () {
      if (_.includes(this.$refs.helpButton.classList, SHOW_HELP_BUTTON_CLASS)) {
        this.$refs.helpButton.classList.remove(SHOW_HELP_BUTTON_CLASS);
      }
      else {
        this.$refs.helpButton.classList.add(SHOW_HELP_BUTTON_CLASS);
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .fixed-support
    position fixed
    bottom 100px
    right 0px
    transform translateX(150%)
    transition all .5s ease
    z-index 9999
  @media print
      .no-print, .no-print *
        display: none !important;
  .support
    border-radius .5rem
    width 300px

  .show-support
    cursor default
    transform translateX(0)

  .fixed-help
    position fixed
    bottom 100px
    right 0px
    transform translateX(100px)
    transition all .5s ease
    z-index 9999

  .help-button
    border-top-right-radius 0
    border-bottom-right-radius 0

  .show-help-button
    transform translateX(0)
</style>
